import {firebaseDb} from '../../firebase';

export const GET_PROJECTS_LIST_REQUEST = 'GET_PROJECTS_LIST_REQUEST';
export const GET_PROJECTS_LIST_SUCCESS = 'GET_PROJECTS_LIST_SUCCESS';
export const GET_PROJECTS_LIST_FAILURE = 'GET_PROJECTS_LIST_FAILURE';

export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';

export const UPDATE_PROJECT_LOGO_SUCCESS = 'UPDATE_PROJECT_LOGO_SUCCESS';
export const UPDATE_PROJECT_LOGO_FAILURE = 'UPDATE_PROJECT_LOGO_FAILURE';

export const getUserProjects = (userId) => dispatch => {
    dispatch({type: GET_PROJECTS_LIST_REQUEST});
    try {
        firebaseDb.ref(`users-projects/${userId}`).on('value', (snapshot) => {
        // firebaseDb.ref(`projects`).on('value', (snapshot) => {
            const projectsFetched = snapshot.val();
            const projects = {};

            for (let p in projectsFetched) {
              const project = projectsFetched[p];
              if (project && project.id) {
                projects[p] = project;
              }
            }


            dispatch({type: GET_PROJECTS_LIST_SUCCESS, payload: projects});
        });
    } catch (error) {
        dispatch({type: GET_PROJECTS_LIST_FAILURE, payload: error});
    }
};

export const getProject = (projectId) => dispatch => {
    dispatch({type: GET_PROJECT_REQUEST});
    try {
        firebaseDb.ref(`projects/${projectId}`).once('value', (snapshot) => {
            dispatch({type: GET_PROJECT_SUCCESS, payload: snapshot.val()});
        })
    } catch (error) {
        dispatch({type: GET_PROJECT_FAILURE, payload: error});
    }
};

export const updateProjectLogo = ({projectId, file}) => async dispatch => {
  try {
    const updates = {};
    updates[`projects/${projectId}/companyLogo`] = file.url;

    await firebaseDb.ref().update(updates);

    dispatch({type: UPDATE_PROJECT_LOGO_SUCCESS, payload: {url: file.url, projectId}});
  } catch (error) {
    dispatch({type: UPDATE_PROJECT_LOGO_FAILURE, payload: error});
  }
};
